/* src/app/features/hero-slider/components/hero-slider.component.scss */
.consent-text {
  font-size: 16px;
}
@media (min-width: 2560px) {
  .consent-text {
    font-size: 19.2px;
  }
}
@media (min-width: 3000px) {
  .consent-text {
    font-size: 23.04px;
  }
}
.font-xxsmall {
  font-size: 12px !important;
}
@media (min-width: 2560px) {
  .font-xxsmall {
    font-size: 14.4px !important;
  }
}
@media (min-width: 3000px) {
  .font-xxsmall {
    font-size: 17.28px !important;
  }
}
.font-xsmall {
  font-size: 13px !important;
}
@media (min-width: 2560px) {
  .font-xsmall {
    font-size: 15.6px !important;
  }
}
@media (min-width: 3000px) {
  .font-xsmall {
    font-size: 18.72px !important;
  }
}
.font-small {
  font-size: 14px !important;
}
@media (min-width: 2560px) {
  .font-small {
    font-size: 16.8px !important;
  }
}
@media (min-width: 3000px) {
  .font-small {
    font-size: 20.16px !important;
  }
}
.font-medium {
  font-size: 16px !important;
}
@media (min-width: 2560px) {
  .font-medium {
    font-size: 19.2px !important;
  }
}
@media (min-width: 3000px) {
  .font-medium {
    font-size: 23.04px !important;
  }
}
.font-large {
  font-size: 18px !important;
}
@media (min-width: 2560px) {
  .font-large {
    font-size: 21.6px !important;
  }
}
@media (min-width: 3000px) {
  .font-large {
    font-size: 25.92px !important;
  }
}
.font-xlarge {
  font-size: 24px !important;
}
@media (min-width: 2560px) {
  .font-xlarge {
    font-size: 28.8px !important;
  }
}
@media (min-width: 3000px) {
  .font-xlarge {
    font-size: 34.56px !important;
  }
}
.font-xxlarge {
  font-size: 28px !important;
}
@media (min-width: 2560px) {
  .font-xxlarge {
    font-size: 33.6px !important;
  }
}
@media (min-width: 3000px) {
  .font-xxlarge {
    font-size: 40.32px !important;
  }
}
.font-xxxlarge {
  font-size: 36px !important;
}
@media (min-width: 2560px) {
  .font-xxxlarge {
    font-size: 43.2px !important;
  }
}
@media (min-width: 3000px) {
  .font-xxxlarge {
    font-size: 51.84px !important;
  }
}
:root {
  --font-family: Roboto, sans-serif;
  --font-xxsmall: 12px;
  --font-xsmall: 13px;
  --font-small: 14px;
  --font-medium: 16px;
  --font-large: 18px;
  --font-xlarge: 24px;
  --font-xxlarge: 28px;
  --font-xxxlarge: 36px;
  --scale-factor-2560: 1.2;
  --scale-factor-3840: 1.2;
  --button-large: 50px;
  --button-medium: 45px;
  --button-small: 40px;
  --button-xsmall: 35px;
  --button-xxsmall: 30px;
  --header-height: 95px;
  --header-height-scrolled: 80px;
  --sidebar-width: 350px;
  --base-cover-radius: 50px;
  --base-tile-radius: 20px;
  --base-form-radius: 30px;
  --base-programme-tile-radius: 6px;
  --transition-function: cubic-bezier(0.02, 0.01, 0.47, 1);
  --transition-duration-xs: 0.15s;
  --transition-duration-sm: 0.25s;
  --transition-duration: 0.35s;
  --transition-duration-lg: 0.5s;
  --mini-details-z-index: 1100000;
  --player-z-index: 1054;
  --details-z-index: 9999999;
}
:host {
  white-space: normal;
  display: inline-block;
  width: 100vw;
  height: 46.25vw;
  min-height: 600px;
  position: relative;
  color: black;
}
.slider {
  position: relative;
  width: 100%;
  height: 100%;
  margin: auto;
  overflow: hidden;
}
.slides {
  position: absolute;
  display: flex;
  width: 100%;
  height: 100%;
  transition: transform 1s ease-in-out;
}
.slides .slide {
  position: relative;
  min-width: 100%;
  height: 100%;
  background-size: cover;
  background-position: top;
  background-repeat: no-repeat;
}
.player {
  position: absolute;
  width: 100%;
  height: 100%;
  visibility: hidden;
  opacity: 0;
  transition: opacity 0.4s ease-in-out, visibility 0s linear 0.4s;
}
.playing {
  visibility: visible;
  opacity: 1;
  transition: opacity 0.4s ease-in-out, visibility 0s;
}
.content {
  position: absolute;
  bottom: 215px;
  color: white;
  gap: 20px;
  z-index: 1;
  max-width: 50%;
}
@media screen and (max-width: 1600px) {
  .content {
    max-width: 60%;
  }
}
@media screen and (max-width: 1368px) {
  .content {
    max-width: 70%;
  }
}
@media screen and (max-width: 768px) {
  .content {
    max-width: 90%;
  }
}
.content .badge {
  border-radius: 18px;
  padding: 6px 18px 6px 18px;
  font-size: 12px;
  font-weight: 100;
  width: fit-content;
}
.content .badge.no-title-badge {
  margin-bottom: 15px;
}
.content .description {
  font-weight: 300;
}
@media screen and (max-width: 768px) {
  .content .description {
    display: none;
  }
}
.actions {
  position: absolute;
  bottom: 140px;
  gap: 20px;
  z-index: 1;
  color: var(--text_primary);
}
.actions .dots {
  margin: auto 0 auto auto;
}
@media screen and (max-width: 768px) {
  .actions .dots {
    display: none;
  }
}
.actions .dots span {
  display: inline-block;
  width: 8px;
  height: 8px;
  background-color: var(--text_secondary);
  margin: 0 4px;
  border-radius: 50%;
  cursor: pointer;
  transition: background-color 0.3s ease;
}
.actions .dots .active {
  background-color: var(--text_primary);
}
.nav {
  z-index: 2;
  position: absolute;
  top: 40%;
}
.left {
  left: 50px;
}
@media screen and (max-width: 1368px) {
  .left {
    left: 35px;
  }
}
@media screen and (max-width: 768px) {
  .left {
    left: 20px;
  }
}
.right {
  right: 50px;
}
@media screen and (max-width: 1368px) {
  .right {
    right: 35px;
  }
}
@media screen and (max-width: 768px) {
  .right {
    right: 20px;
  }
}
.shadow {
  z-index: 0;
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0px;
  top: 0px;
}
.shadow.notext {
  height: 25%;
  top: 75%;
}
.mute-btn {
  position: absolute;
  visibility: hidden;
  opacity: 0;
  z-index: 2;
  right: 40px;
  bottom: 200px;
}
.mute-btn.playing {
  visibility: visible;
  opacity: 1;
  transition: opacity 0.4s ease-in-out, visibility 0s;
}
.play-btn {
  z-index: 2;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.navigation-buttons {
  opacity: 0;
  transition: opacity 0.15s cubic-bezier(0.02, 0.01, 0.47, 1);
}
.navigation-buttons.focused {
  opacity: 1;
}
@media (hover: none) {
  .navigation-buttons {
    opacity: 1;
  }
}
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.animate-content {
  animation: fadeInUp 0.8s ease-out forwards;
}
.content,
.actions {
  opacity: 0;
}
/*# sourceMappingURL=hero-slider.component.css.map */
